var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "camera-fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875@20230203",
    transform: "translate(-679.000000, -123.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12",
    transform: "translate(679.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "camera-fill",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1666667,7 C23.133165,7 23.9166667,7.78350169 23.9166667,8.75 L23.9166667,20.4166667 C23.9166667,21.383165 23.133165,22.1666667 22.1666667,22.1666667 L5.83333332,22.1666667 C4.86683501,22.1666667 4.08333332,21.383165 4.08333332,20.4166667 L4.08333332,8.75 C4.08333332,7.78350169 4.86683501,7 5.83333332,7 L22.1666667,7 L22.1666667,7 Z M14,10.5 C11.7448373,10.5 9.91666666,12.3281706 9.91666666,14.5833333 C9.91666666,16.8384961 11.7448373,18.6666667 14,18.6666667 C16.2551627,18.6666667 18.0833333,16.8384961 18.0833333,14.5833333 C18.0833333,12.3281706 16.2551627,10.5 14,10.5 Z M14,12.25 C15.2886644,12.25 16.3333333,13.2946689 16.3333333,14.5833333 C16.3333333,15.8719978 15.2886644,16.9166667 14,16.9166667 C12.7113356,16.9166667 11.6666667,15.8719978 11.6666667,14.5833333 C11.6666667,13.2946689 12.7113356,12.25 14,12.25 Z M22.1666667,4.08333332 L22.1666667,5.83333332 L14,5.83333332 L14,4.08333332 L22.1666667,4.08333332 Z",
    id: "\\u5F62\\u72B6",
    fill: "currentColor"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraFill);
export default __webpack_public_path__ + "static/media/camera-fill.7989ba41cddbf9254791e258b1795384.svg";
export { ForwardRef as ReactComponent };